// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Auth Container */

  
  .auth-card {
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.5);
    padding: 1.5em;
    border-radius: 15px;
  }
  
  .auth-card .card-title, .auth-card .card-text {
    color: #fff;
  }
  
 
  .auth-success {
    color: green;
    font-size: 1rem;
  }
  
  .auth-error {
    color: red;
    font-size: 1rem;
  }
  
  .ml-2 {
    margin-left: 1em;
  }
  
  .profile-info {
    display: flex;
    flex-direction: column;
    gap: 1.2em;  /* Adds space between each profile item */
  }
  
  .info-item {
    display: flex;
    justify-content: space-between;  /* Aligns the label and value horizontally */
    align-items: center;
  }
  
  .info-item .card-title {
    font-weight: bold;
    margin: 0;
    color: #fff;
  }
  
  .info-item .ti {
    font-weight: normal;
    margin: 0;
    color: #dcdcdc;
  }
  
  .verification-buttons {
    margin-top: 1.5em;
    display: flex;
    justify-content: flex-start;
    gap: 1em;  /* Space between buttons */
  }
  

.ver {
    margin-top: 20px;
}

/* General Styles */
.profile-container {
    text-align: center;
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  

  
  /* Modal Backdrop */
  .custom-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8); /* Dark background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Modal Styling */
  .custom-modal {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    position: relative;
  }
  
  .custom-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .custom-modal-header h3 {
    margin: 0;
  }
  
  .close-button {
    background: none;
    border: none;
    font-size: 1.2rem;
    cursor: pointer;
  }
  
  .custom-modal-body {
    margin: 20px 0;
  }
  
  .verification-input {
    width: 90%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #027b9a;
    color: #027b9a;
    background: #004658;
    border-radius: 4px;
  }

  .verification-input::placeholder {
    color: #027b9a;
  }

  .verification-input:hover::placeholder {
    color: #004658;
  }

  .verification-input:hover {
    border: 1px solid #004658;
    color: #004658;
    background: #027b9a;
    border-radius: 4px;
  }
  
  .custom-modal-footer {
    display: flex;
    justify-content: space-between;
  }
  
  .cancel-button {
    border: 1px solid #004658;
    color: #004658;
    background: #027b9a;
    padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  
  .cancel-button:hover {
    border: 1px solid #027b9a;
    color: #027b9a;
    background: #004658;
  }
  

  @media (max-width: 768px) {
    .auth-card {
      padding: 1em;
    }
  
    .info-item {
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5em;
    }
  
    .custom-modal {
      width: 95%;
      max-width: none;
    }
  
    .verification-input {
      width: 100%;
      padding: 12px;
    }
  
    .verification-buttons {
      flex-direction: column;
    }
  
    .cancel-button {
      padding: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .auth-card {
      padding: 0.8em;
    }
  
    .info-item {
      font-size: 0.9rem;
    }
  
    .custom-modal {
      padding: 15px;
      width: 100%;
    }
  
    .verification-input {
      padding: 10px;
      font-size: 0.9rem;
    }
  
    .verification-buttons {
      gap: 0.5em;
    }
  
    .cancel-button {
      padding: 8px 15px;
      font-size: 0.9rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/profile.css"],"names":[],"mappings":"AAAA,0BAA0B;;;EAGxB;IACE,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU,GAAG,yCAAyC;EACxD;;EAEA;IACE,aAAa;IACb,8BAA8B,GAAG,4CAA4C;IAC7E,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,QAAQ,GAAG,0BAA0B;EACvC;;;AAGF;IACI,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;EAChC;;;;EAIA,mBAAmB;EACnB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,oBAAoB;IAC1D,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;EACrB;;;EAGA;IACE;MACE,YAAY;IACd;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,UAAU;IACZ;;IAEA;MACE,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,WAAW;IACb;;IAEA;MACE,aAAa;MACb,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF","sourcesContent":["/* Common Auth Container */\n\n  \n  .auth-card {\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    padding: 1.5em;\n    border-radius: 15px;\n  }\n  \n  .auth-card .card-title, .auth-card .card-text {\n    color: #fff;\n  }\n  \n \n  .auth-success {\n    color: green;\n    font-size: 1rem;\n  }\n  \n  .auth-error {\n    color: red;\n    font-size: 1rem;\n  }\n  \n  .ml-2 {\n    margin-left: 1em;\n  }\n  \n  .profile-info {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2em;  /* Adds space between each profile item */\n  }\n  \n  .info-item {\n    display: flex;\n    justify-content: space-between;  /* Aligns the label and value horizontally */\n    align-items: center;\n  }\n  \n  .info-item .card-title {\n    font-weight: bold;\n    margin: 0;\n    color: #fff;\n  }\n  \n  .info-item .ti {\n    font-weight: normal;\n    margin: 0;\n    color: #dcdcdc;\n  }\n  \n  .verification-buttons {\n    margin-top: 1.5em;\n    display: flex;\n    justify-content: flex-start;\n    gap: 1em;  /* Space between buttons */\n  }\n  \n\n.ver {\n    margin-top: 20px;\n}\n\n/* General Styles */\n.profile-container {\n    text-align: center;\n    padding: 20px;\n    font-family: Arial, sans-serif;\n  }\n  \n\n  \n  /* Modal Backdrop */\n  .custom-modal-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8); /* Dark background */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  /* Modal Styling */\n  .custom-modal {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 8px;\n    width: 400px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    position: relative;\n  }\n  \n  .custom-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .custom-modal-header h3 {\n    margin: 0;\n  }\n  \n  .close-button {\n    background: none;\n    border: none;\n    font-size: 1.2rem;\n    cursor: pointer;\n  }\n  \n  .custom-modal-body {\n    margin: 20px 0;\n  }\n  \n  .verification-input {\n    width: 90%;\n    padding: 10px;\n    font-size: 1rem;\n    border: 1px solid #027b9a;\n    color: #027b9a;\n    background: #004658;\n    border-radius: 4px;\n  }\n\n  .verification-input::placeholder {\n    color: #027b9a;\n  }\n\n  .verification-input:hover::placeholder {\n    color: #004658;\n  }\n\n  .verification-input:hover {\n    border: 1px solid #004658;\n    color: #004658;\n    background: #027b9a;\n    border-radius: 4px;\n  }\n  \n  .custom-modal-footer {\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .cancel-button {\n    border: 1px solid #004658;\n    color: #004658;\n    background: #027b9a;\n    padding: 10px 20px;\n    font-size: 1rem;\n    cursor: pointer;\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .cancel-button:hover {\n    border: 1px solid #027b9a;\n    color: #027b9a;\n    background: #004658;\n  }\n  \n\n  @media (max-width: 768px) {\n    .auth-card {\n      padding: 1em;\n    }\n  \n    .info-item {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.5em;\n    }\n  \n    .custom-modal {\n      width: 95%;\n      max-width: none;\n    }\n  \n    .verification-input {\n      width: 100%;\n      padding: 12px;\n    }\n  \n    .verification-buttons {\n      flex-direction: column;\n    }\n  \n    .cancel-button {\n      padding: 10px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .auth-card {\n      padding: 0.8em;\n    }\n  \n    .info-item {\n      font-size: 0.9rem;\n    }\n  \n    .custom-modal {\n      padding: 15px;\n      width: 100%;\n    }\n  \n    .verification-input {\n      padding: 10px;\n      font-size: 0.9rem;\n    }\n  \n    .verification-buttons {\n      gap: 0.5em;\n    }\n  \n    .cancel-button {\n      padding: 8px 15px;\n      font-size: 0.9rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
